import { Routes } from '@angular/router';
import { LogoutComponent } from './components/logout/logout.component';
import { TacitComponent } from './components/tacit/tacit.component';
import { AdminRoleGuard } from './guards/admin-role.guard';
import { AuthorizedGuard } from './guards/authorized.guard';
import { BasicRecordsRoleGuard } from './guards/basic-records-role.guard';
import { CallingTreeRoleGuard } from './guards/calling-tree-role.guard';
import { CanViewFullUserGuard } from './guards/can-view-full-user.guard';
import { CrisisTeamRoleGuard } from './guards/crisis-team-role.guard';
import { ExternalRedirectGuard } from './guards/external-redirect.guard';
import { HousingRoleGuard } from './guards/housing-role.guard';
import { ReportRoleGuard } from './guards/report-role.guard';

export const APP_ROUTES: Routes = [
	{ path: '', redirectTo: 'tacit', pathMatch: 'full' },
	{
		path: 'login',
		loadChildren: () =>
			import('./login/login.routes').then((m) => m.LOGIN_ROUTES),
	},
	{ path: 'logout', component: LogoutComponent },
	{
		path: 'tacit',
		component: TacitComponent,
		canActivate: [AuthorizedGuard],
		children: [
			{ path: '', redirectTo: 'dashboard', pathMatch: 'full' },
			{
				path: 'dashboard',
				loadChildren: () =>
					import('./dashboard/dashboard.routes').then(
						(m) => m.DASHBOARD_ROUTES
					),
				data: { preload: true },
			},
			{
				path: 'travel',
				loadChildren: () =>
					import('./travel/travel.routes').then(
						(m) => m.TRAVEL_ROUTES
					),
				data: { preload: true },
			},
			{
				path: 'hr',
				loadChildren: () =>
					import('./hr/hr.routes').then((m) => m.HR_ROUTES),
				canLoad: [CanViewFullUserGuard],
				canActivate: [CanViewFullUserGuard],
			},
			{
				path: 'basic',
				loadChildren: () =>
					import('./basic/basic.routes').then((m) => m.BASIC_ROUTES),
				canLoad: [BasicRecordsRoleGuard],
				canActivate: [BasicRecordsRoleGuard],
			},
			{
				path: 'config',
				loadChildren: () =>
					import('./config/config.routes').then(
						(m) => m.CONFIG_ROUTES
					),
				canLoad: [AdminRoleGuard],
				canActivate: [AdminRoleGuard],
			},
			{
				path: 'help',
				loadChildren: () =>
					import('./help/help.routes').then((m) => m.HELP_ROUTES),
			},
			{
				path: 'my-record',
				loadChildren: () =>
					import('./my-record/my-record.routes').then(
						(m) => m.MY_RECORD_ROUTES
					),
			},
			{
				path: 'housing',
				loadChildren: () =>
					import('./housing/housing.routes').then(
						(m) => m.HOUSING_ROUTES
					),
				canLoad: [HousingRoleGuard],
				canActivate: [HousingRoleGuard],
			},
			{
				path: 'calling-tree',
				loadChildren: () =>
					import('./calling-tree/calling-tree.routes').then(
						(m) => m.CALLING_TREE_ROUTES
					),
				canLoad: [CallingTreeRoleGuard],
				canActivate: [CallingTreeRoleGuard],
			},
			{
				path: 'crisis-team',
				loadChildren: () =>
					import('./crisis-team/crisis-team.routes').then(
						(m) => m.CRISIS_TEAM_ROUTES
					),
				canLoad: [CrisisTeamRoleGuard],
				canActivate: [CrisisTeamRoleGuard],
			},
			{
				path: 'report',
				loadChildren: () =>
					import('./report/report.routes').then(
						(m) => m.REPORT_ROUTES
					),
				canLoad: [ReportRoleGuard],
				canActivate: [ReportRoleGuard],
			},
		],
	},
	{
		path: 'externalRedirect',
		canActivate: [AuthorizedGuard, ExternalRedirectGuard],
		loadChildren: () =>
			import('./page-not-found/page-not-found.routes').then(
				(m) => m.PAGE_NOT_FOUND_ROUTES
			),
	},
	{
		path: '**',
		loadChildren: () =>
			import('./page-not-found/page-not-found.routes').then(
				(m) => m.PAGE_NOT_FOUND_ROUTES
			),
	},
];
